import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Tab,
  Tabs,
  Typography,
  Paper,
  IconButton,
  Button,
  useMediaQuery,
  Modal,
  Fab,
  Alert,
  AlertTitle,
  Snackbar,
} from "@mui/material";
import Layout1 from "../layouts/Layout1";
import Layout2 from "../layouts/Layout2";
import Layout9 from "../layouts/Layout9";
import GrammarSectionLayout from "../layouts/GrammarSectionLayout";
import { useNavigate, useParams } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Layout3 from "../layouts/Layout3";
import Layout13 from "../layouts/Layout13";
import Layout10 from "../layouts/Layout10";
import Layout14 from "../layouts/Layout14";
import Layout15 from "../layouts/Layout15";
import axiosInstance from "../common/services/axiosInstance";
import { useCharactersContext } from "../hooks/Context";
import mascot from "../assets/bird_mascot.png";
import Layout16 from "../layouts/Layout16";
import LayoutRenderer from "../layouts/LayoutRenderer";

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

interface QuestionScore {
  questionBankId: number;
  questionPaperId: number;
  layoutNumber: number;
  score: number;
  sectionName?: string; 
}

interface examAnswers {
  acutalOptionValue: string;
  enteredOptionValue: string;
  studentId: number;
  questionId: number;
  examId: string;
  batchId: number;
  sectionId: number;
  sectionName: string;
  marks: number;
  examParticipationId: number;
  active: boolean;
  createdBy: string;
  createdDt: string;
  lastUpdatedBy: string;
  lastUpdatedDt: string;
}

interface QuestionPaper {
  name: string;
  sectionList: {
    name: string;
    id: number;
    questionBank: any[];
  }[];
}

interface ExitModalProps {
  showExitModal: boolean;
}

interface LayoutResult {
  layoutNumber: number;
  layoutScore: number;
}

interface SectionResult {
  sectionResultId: number;
  examParticipationId: number;
  studentId: number;
  sectionId: number;
  startTime: string;
  sectionName: string;
  totalQuestions: number;
  answeredQuestions: number;
  correctAnswered: number;
  active: boolean;
  createdBy: string;
  createdDt: string;
  lastUpdatedBy: string;
  lastUpdatedDt: string;
  marksScored: number;
}

interface ExamId {
  examId: number;
}

interface BatchId {
  batchId: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};

const Homework = () => {
  const {
    questionScores,
    studentId,
    isViewMode,
    examAnswers,
    setExamAnswers,
    completedLessons,
  } = useCharactersContext();
  const presentStudentId = Number(localStorage.getItem("studentId"));

  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:820px)");
  const [modalOpen, setModalOpen] = useState(false);
  const [viewModeAnsweredQuestions, setViewModeAnsweredQuestions] = useState();
  const [viewModeCorrectAnswered, setViewModeCorrectAnswered] = useState();
  const [viewModeMarksScored, setViewModeMarksScored] = useState();
  const [showInfoAlert, setShowInfoAlert] = useState<boolean>(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [sectionId, setSectionId] = useState<Number>();
  const [examAnswersPayloads, setExamAnswersPayloads] = useState<any[]>([]);
  let questionBankScore: QuestionScore[] = [];
  const [lessonName, setLessonName] = useState();

  const [submissionStatus, setSubmissionStatus] = useState<
    "success" | "failure" | null
  >(null);

  const { moduleId, levelId, lessonId } = useParams();

  const [tabValue, setTabValue] = useState(0);
  const [questionPaper, setQuestionPaper] = React.useState<QuestionPaper>({
    name: "",
    sectionList: [],
  });

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const navigate = useNavigate();

  const [currentQuestionPaperId, setCurrentQuestionPaperId] =
    useState<number>(0);

  useEffect(() => {
    if (isViewMode) {
      setShowInfoAlert(true);
    }
  }, [isViewMode]);

  useEffect(() => {
    axiosInstance
      .get(
        `/api/question/questionPaper/info/${lessonId}/${levelId}/1/${presentStudentId}`
      )
      .then((response) => {
        //console.log("responseData", response.data);
        const questionPaperData = response.data.responseData[0];
        setLessonName(questionPaperData.name);
        setQuestionPaper(questionPaperData);
        setCurrentQuestionPaperId(questionPaperData.questionPaperId);
        localStorage.setItem(
          "presentQuestionPaperId",
          questionPaperData.questionPaperId
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    const presentQuestionPaperId = Number(
      localStorage.getItem("presentQuestionPaperId")
    );

    if (!presentStudentId || !presentQuestionPaperId) return;

    axiosInstance
      .get("/api/examinationParticipation/examParticipation/get", {
        params: {
          studentId: presentStudentId,
          questionPaperId: presentQuestionPaperId,
        },
      })
      .then((response) => {
        const participation = response.data[0];

        if (!participation) {
          console.warn("No participation record found for the given filters.");
          return;
        }

        setViewModeAnsweredQuestions(participation.answeredQuestions);
        setViewModeCorrectAnswered(participation.correctAnswered);
        setViewModeMarksScored(participation.marksScored);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [currentQuestionPaperId]);

  // console.log("questions:", questionPaper);

  // console.log("Marks scored", viewModeMarksScored);

  useEffect(() => {
    const handleResize = () => {
      const tabContent = document.querySelector(".tab-content") as HTMLElement;

      if (tabContent) {
        tabContent.style.height = "100%";
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (!questionPaper || !questionPaper.sectionList) {
    return (
      <>
        <Box display="flex" justifyContent="center" sx={{ marginTop: "50vh" }}>
          Questions have not been added yet for this lesson
        </Box>
      </>
    );
  }

  const totalQuestions = questionPaper.sectionList.reduce(
    (count: number, section: any) => count + section.questionBank.length,
    0
  );

  const answeredQuestionsSet = new Set();
  questionScores.forEach((score) => {
    if (score.questionPaperId === currentQuestionPaperId) {
      answeredQuestionsSet.add(score.questionBankId);
    }
  });

  const answeredQuestions = answeredQuestionsSet.size;
  // console.log("answeredQuestions home", answeredQuestions);

  const correctlyAnsweredQuestions = questionScores.filter((score) => {
    return score.questionPaperId === currentQuestionPaperId && score.score > 0;
  }).length;
  //console.log("correctlyAnsweredQuestions", correctlyAnsweredQuestions);

  const currentStudentId = studentId || Number(localStorage.getItem("studentId")) || 0;

  const modalStyle = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "30vh" : isTablet ? "40vh" : "65vh",
    bgcolor: "background.paper",
    borderRadius: "10px",
    boxShadow: 24,
    p: 2.5,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const modalStyle2 = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "30vh" : isTablet ? "40vh" : "65vh",
    bgcolor: "#245CA6",
    borderRadius: "10px",
    boxShadow: 24,
    p: 2.5,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const saveHomework = () => {
    let examParticipationId: number;
    let uniqueQuestionBankIds: number[] = [];

    const calculateLayoutScore = (
      questionScores: QuestionScore[],
      currentQuestionPaperId: number,
      layoutNumber: number
    ): number => {
      // console.log("currentQuestionPaperId:", currentQuestionPaperId);
      // console.log("layoutNumber:", layoutNumber);
      const filteredScores = questionScores.filter((score) => {
        return (
          score.questionPaperId === currentQuestionPaperId &&
          score.layoutNumber === layoutNumber
        );
      });

      //console.log("Filtered Scores:", filteredScores);
      // Assign the filtered scores to the 'examAnswer' variable
      questionBankScore = filteredScores;

      // console.log("layoutNumber ", layoutNumber);

      // Calculate the total score for the specified layoutNumber
      const layoutScore = filteredScores.reduce((totalScore, score) => {
        return totalScore + score.score;
      }, 0);

      // console.log("Layout Score12:", layoutScore);
      return layoutScore;
    };

    // Calculate scores for layouts 1, 2, 3, 9, 11, 12, 13, 10, 14, 15, 16, 17, 18, 19, 20, and 21
    const layoutNumbersToCalculate: number[] = [
      1, 2, 3, 9, 11, 12, 13, 10, 14, 15, 16, 17, 18, 19, 20, 21,
    ];
    const layoutScores: Record<string, number> = {};

    layoutNumbersToCalculate.forEach((layoutNumber) => {
      const layoutScore = calculateLayoutScore(
        questionScores,
        currentQuestionPaperId,
        layoutNumber
      );

      layoutScores[`layout${layoutNumber}Score`] = layoutScore;
      // console.log(`layoutNumber: ${layoutNumber}, layoutScore: ${layoutScore}`);
    });
    // console.log("sctionId", sectionId);
    // console.log("Layout Scores:", layoutScores);
    // console.log("LessonId", lessonId);

    const marksScored = Object.values(layoutScores).reduce((total, score) => {
      return total + score;
    }, 0);

    // console.log("Marks Scored:", marksScored);

    const numberOfQuestions = questionPaper.sectionList.length;
    // console.log("Number of questions:", numberOfQuestions);

    interface Payload {
      sectionId: number;
      studentId: number;
      sectionName: string;
      totalQuestions: number;
      answeredQuestions: number;
      marksScored: number;
      active: boolean;
      correctAnswered: number;
      examParticipationId: number;
    }

    const requestBodyForExamParticipation = {
      examStatus: "completed",
      marksScored: marksScored,
      questionPaperId: currentQuestionPaperId,
      active: true,
      resultSent: false,
      examId: lessonId,
      studentId: currentStudentId,
      totalQuestions: totalQuestions,
      answeredQuestions: answeredQuestions,
      correctAnswered: correctlyAnsweredQuestions,
      examinationId: moduleId,
      classId: levelId,
    };

    axiosInstance
      .post(
        "/api/examinationParticipation/examParticipation/save",
        requestBodyForExamParticipation
      )
      .then((examParticipationResponse) => {
        examParticipationId =
          examParticipationResponse.data.examParticipationId;
        console.log(
          "Exam participation saved successfully:",
          examParticipationResponse.data
        );

        // Create the layoutResultsArray using the LayoutResult type
        const layoutResultsArray: LayoutResult[] = layoutNumbersToCalculate.map(
          (layoutNumber) => {
            return {
              layoutNumber,
              layoutScore: layoutScores[`layout${layoutNumber}Score`],
            };
          }
        );

        // Helper function to get actual layout numbers from question scores for a section
        const getActualLayoutNumbersForSection = (sectionName: string): number[] => {
          const layoutNumbersSet = new Set<number>();
          questionScores.forEach((score) => {
            if (
              score.questionPaperId === currentQuestionPaperId &&
              score.sectionName?.toLowerCase() === sectionName.toLowerCase()
            ) {
              layoutNumbersSet.add(score.layoutNumber);
            }
          });
          return Array.from(layoutNumbersSet);
        };

        // Assuming a manually set layoutNumber for each section
        const manuallySetLayoutNumbers: Record<string, number | number[]> = {
          Phonics: 1,
          Syllabification: [1, 18],
          Blends: 2,
          HFW: 16,
          Dictionary: [3, 9],
          "Read & Comprehend": [9, 11, 21],
          "Reading and Comprehension": [9, 11, 21],
          "Reading & Comprehension": [9, 11, 21],
          "Book Review": [9, 11, 21],
          Grammar: [9, 11, 12, 17, 18, 19, 20],
          "Think & Choose": [13, 19],
          "Think and Choose": [13, 19],
          Crossword: 10,
          "Guess who/what am I": 14,
          "How many can you think of": 15,
          Pictionary: 11,
          "Misspelt Words": 11,
          "Misspelt words": 11,
          "Spot the intruder": 17,
          "Picture Decoding": 11,
          "Antonym Challenge": 18,
          "Antonym challenge": 18,
          "Vocabulary Exercise": 9,
          "Vocabulary exercise": 9,
          "Spot the injustice": 9,
          "Understanding cause and effect": 9,
          "World of Professions": 9,
          "Career options": 9,
        };

        const requestBodyForSectionResults: Payload[] = [];
        let pictionaryProcessed = false; // Track if Pictionary layout 11 is already processed

        questionPaper.sectionList.forEach((section) => {
          const sectionName: string = section.name;
          console.log("sectionName", sectionName);

          // Get the manually set layoutNumbers for the section
          let layoutNumbers = manuallySetLayoutNumbers[sectionName];
          if (!layoutNumbers) {
            const foundKey = Object.keys(manuallySetLayoutNumbers).find(
              (key) => key.toLowerCase() === sectionName.toLowerCase()
            );
            if (foundKey) {
              layoutNumbers = manuallySetLayoutNumbers[foundKey];
            }
          }
          
          // If no mapping exists, try to detect from actual question scores
          if (!layoutNumbers) {
            const actualLayoutNumbers = getActualLayoutNumbersForSection(sectionName);
            if (actualLayoutNumbers.length > 0) {
              layoutNumbers = actualLayoutNumbers.length === 1 ? actualLayoutNumbers[0] : actualLayoutNumbers;
            } else {
              return; // Skip this section if no mapping and no questions
            }
          }
          
          const layoutNumberArray = Array.isArray(layoutNumbers)
            ? layoutNumbers
            : [layoutNumbers];

          // Filter to only include layout numbers that have actual questions for this section
          const actualLayoutNumbersForSection = getActualLayoutNumbersForSection(sectionName);
          const validLayoutNumbers = actualLayoutNumbersForSection.length > 0
            ? layoutNumberArray.filter(layoutNum => actualLayoutNumbersForSection.includes(layoutNum))
            : layoutNumberArray.slice(0, 1);

          if (validLayoutNumbers.length === 0) {
            return;
          }

          // Iterate over valid layout numbers
          validLayoutNumbers.forEach((layoutNumber) => {
            // Skip creating duplicate Grammar layout 11 if Pictionary layout 11 is already processed
            if (
              layoutNumber === 11 &&
              sectionName.toLowerCase() === "grammar" &&
              pictionaryProcessed
            ) {
              console.warn(
                `Skipping duplicate Grammar layout 11 because Pictionary layout 11 is already processed.`
              );
              return; // Skip creating a duplicate Grammar entry
            }

            // Filter layoutResultsArray for the section and layout number
            const layoutResultsForSection: LayoutResult[] =
              layoutResultsArray.filter(
                (result) => result.layoutNumber === layoutNumber
              );

            if (layoutResultsForSection.length === 0) {
              console.warn(
                `Layout result not found for section: ${sectionName}`
              );
              return;
            }

            const layoutResult = layoutResultsForSection[0];

            const answeredQuestionsSetForEachSection = new Set();

            questionScores.forEach((score) => {
              if (
                score.questionPaperId === currentQuestionPaperId &&
                score.layoutNumber === layoutResult.layoutNumber &&
                score.sectionName?.toLowerCase() === sectionName.toLowerCase()
              ) {
                answeredQuestionsSetForEachSection.add(score.questionBankId);
                uniqueQuestionBankIds.push(score.questionBankId);
              }
            });

            const answeredQuestions = answeredQuestionsSetForEachSection.size;

            const correctlyAnsweredQuestions = questionScores.filter(
              (score) =>
                score.questionPaperId === currentQuestionPaperId &&
                score.layoutNumber === layoutResult.layoutNumber &&
                score.sectionName?.toLowerCase() === sectionName.toLowerCase() &&
                score.score > 0
            ).length;

            // Calculate marksScored specifically for this section
            const sectionMarksScored = questionScores
              .filter(
                (score) =>
                  score.questionPaperId === currentQuestionPaperId &&
                  score.layoutNumber === layoutResult.layoutNumber &&
                  score.sectionName?.toLowerCase() === sectionName.toLowerCase()
              )
              .reduce((total, score) => total + score.score, 0);

            const totalQuestions =
              sectionName.toLowerCase() === "crossword"
                ? 5
                : section.questionBank.length;

            const defaultansweredQuestions =
              sectionName.toLowerCase() === "crossword" ? 5 : answeredQuestions;

            const defaultCorrectlyAnsweredQuestions =
              sectionName.toLowerCase() === "crossword"
                ? sectionMarksScored
                : correctlyAnsweredQuestions;

            const payload: Payload = {
              sectionId: layoutResult.layoutNumber,
              studentId: currentStudentId,
              sectionName: sectionName,
              totalQuestions: totalQuestions,
              answeredQuestions: defaultansweredQuestions,
              marksScored: sectionMarksScored,
              active: true,
              correctAnswered: defaultCorrectlyAnsweredQuestions,
              examParticipationId: examParticipationId,
            };

            // Add payload to results
            requestBodyForSectionResults.push(payload);

            // Track if Pictionary layout 11 is processed
            if (layoutNumber === 11 && sectionName === "Pictionary") {
              pictionaryProcessed = true;
            }
          });
        });

        const filteredResults: Payload[] = requestBodyForSectionResults.filter(
          (result) =>
            !(
              result?.answeredQuestions === 0 &&
              result?.sectionName.toLowerCase() === "grammar"
            )
        );

        return axiosInstance.post(
          "/api/examinationParticipation/sectionResults/save",
          filteredResults
        );
      })
      .then((sectionResultsResponse) => {
        console.log(
          "Section Results saved successfully:",
          sectionResultsResponse.data
        );
        setSubmissionStatus("success");
        return saveExamAnswers(sectionResultsResponse.data);
      })
      .then(() => {
        setTimeout(() => {
          navigate(-1);
        }, 4000);
        setModalOpen(false);
        setShowExitModal(true);
      })

      .catch((error) => {
        console.error(
          "Error saving exam participation or section results:",
          error
        );
        setSubmissionStatus("failure");
        setModalOpen(false);
      });
  };

  const saveExamAnswers = async (sectionResults: SectionResult[]) => {
    try {
      let examAnswersPayloads = [];
      const uniqueQuestionIds = new Set<number>();

      for (const sectionResult of sectionResults) {
        const { examParticipationId, sectionId, sectionName, marksScored } =
          sectionResult;

        // Filter questionScores for the current section
        const sectionQuestionScores = questionScores.filter(
          (score) => 
            score.questionBankId && 
            score.layoutNumber === sectionId &&
            score.questionPaperId === currentQuestionPaperId &&
            score.sectionName === sectionName
        );

        // Iterate through each questionBankId in the array
        for (const score of sectionQuestionScores) {
          const { questionBankId } = score;

          // Ensure questionBankId is unique for the current section
          if (
            !uniqueQuestionIds.has(questionBankId) &&
            currentQuestionPaperId === score.questionPaperId &&
            sectionName === score.sectionName
          ) {
            uniqueQuestionIds.add(questionBankId);

            const relevantAnswers = examAnswers.filter(
              (answer) => answer.questionBankId === questionBankId
            );

            const combinedActualOption = relevantAnswers
              .map((answer) => answer.acutalOptionValue)
              .join(", ")
              .toLowerCase();

            const combinedEnteredOption = relevantAnswers
              .map((answer) => answer.enteredOptionValue)
              .join(", ")
              .toLowerCase();

            const scoreInQuestionScores = questionScores.find(
              (s) =>
                s.questionPaperId === currentQuestionPaperId &&
                s.questionBankId === questionBankId &&
                s.sectionName === sectionName
            );
            const marks =
              sectionName === "Crossword"
                ? marksScored
                : scoreInQuestionScores && scoreInQuestionScores.score > 0
                ? 1
                : 0;

            const examAnswersPayload = {
              examParticipationId,
              acutalOptionValue: combinedActualOption,
              enteredOptionValue: combinedEnteredOption,
              studentId: currentStudentId,
              questionId: questionBankId,
              examId: lessonId ? { examId: lessonId } : undefined,
              batchId: { batchId: 1 },
              active: true,
              marks: marks,
              sectionId,
              sectionName,
            };

            examAnswersPayloads.push(examAnswersPayload);
          }
        }
      }

      const response = await axiosInstance.post(
        "/api/examinationParticipation/examAnswers/save",
        examAnswersPayloads
      );
      // console.log("Exam answers saved successfully:", response.data);
      setExamAnswersPayloads([]);
      setSubmissionStatus("success");
      // console.log(examAnswersPayloads, "examAnswersPayloads");
    } catch (error: any) {
      console.error("Error saving exam answers:", error);
      if (error.response) {
        console.error("Server responded with:", error.response.data);
      } else if (error.request) {
        console.error("No response received from the server");
      } else {
        console.error("Request setup error:", error.message);
      }
      setSubmissionStatus("failure");
    }
  };

  const ExitModal: React.FC<ExitModalProps> = ({ showExitModal }) => {
    return (
      <Modal open={showExitModal} onClose={() => setShowExitModal(false)}>
        <Box sx={modalStyle2}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Fab
              variant="extended"
              sx={{
                fontWeight: 800,
                fontSize: isMobile ? "65%" : "auto",
                fontFamily: '"Nunito","Segoe UI", sans-serif',
                backgroundColor: "#D9F6FF !important",
                p: isMobile ? 2.5 : 2,
                height: "fit-content",
                width: "fit-content",
                cursor: "default",
              }}
            >
              {getRandomQuote()}
            </Fab>
            <img
              src={mascot}
              alt="mascot"
              style={{ width: "30%", height: "30%" }}
            />
          </div>
        </Box>
      </Modal>
    );
  };

  const getRandomQuote = () => {
    const quotes = [
      "Learning is fun! Great job on getting it done! 🚀📚🌟",
      "You've done great! Keep going and never give up! 😊📚✨",
      "Great job on completing the homework, keep learning, little star!",
      "Every day you learn and grow, and that's how bright futures are made. 🌟📚💪",
      "You are amazing! Learning new things is awesome and so are you! 😍📚🚀",
      "Wow, you did it! You learned something new today and that’s fantastic! 🎉📚🌟",
      "You’re a star! Learning is a superpower and you have it! 🌠📚💯",
      "You rock! Learning is a wonderful journey and you’re on the right track! 🤩📚👏",
    ];

    const randomIndex = Math.floor(Math.random() * quotes.length);
    return quotes[randomIndex];
  };
  return (
    <Box sx={{ marginTop: isMobile ? "10vh" : isTablet ? "8vh" : "12vh" }}>
      <Modal open={modalOpen} onClose={handleClose}>
        <Box sx={modalStyle}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Fab
              variant="extended"
              sx={{
                fontWeight: 800,
                fontSize: isMobile ? "65%" : "auto",
                fontFamily: '"Nunito","Segoe UI", sans-serif',
                backgroundColor: "#D9F6FF !important",
                p: isMobile ? 2.5 : 2,
                minHeight: isMobile ? "10vh" : "auto",
                cursor: "default",
              }}
            >
              Are you sure you want to submit the homework ?
            </Fab>
            <img
              src={mascot}
              alt="mascot"
              style={{ width: "30%", height: "30%" }}
            />
          </div>
          <Box sx={{ marginTop: "2vh" }}>
            <Button
              variant="contained"
              onClick={saveHomework}
              sx={{
                borderRadius: "15px",
                backgroundColor: "primary.main",
                marginRight: "1vh",
              }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              sx={{ borderRadius: "15px", backgroundColor: "secondary.main" }}
              onClick={handleClose}
            >
              No
            </Button>
          </Box>
        </Box>
      </Modal>
      <ExitModal showExitModal={showExitModal} />
      {submissionStatus === "success" && (
        <Alert severity="success">
          <AlertTitle>Homework submitted</AlertTitle>
          Your homework has been successfully submitted.
        </Alert>
      )}

      {submissionStatus === "failure" && (
        <Alert severity="error">
          <AlertTitle>Homework not submitted</AlertTitle>
          There was an error submitting your homework. Please try again later.
        </Alert>
      )}

      <Snackbar
        open={showInfoAlert}
        // autoHideDuration={6000}
        onClose={() => setShowInfoAlert(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          severity="warning"
          // variant="outlined"
          onClose={() => setShowInfoAlert(false)}
        >
          <AlertTitle>Displaying correct answers of each question</AlertTitle>
        </Alert>
      </Snackbar>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="stretch"
        p={2}
        borderRadius={3}
        m={2}
        // bgcolor="#F2F2F2"
        sx={{
          height: isMobile ? "3vh" : isTablet ? "4vh" : "6vh",
          marginBottom: "0vh !important",
          padding: "0px",
          margin: isMobile ? "5vw" : isTablet ? "2.5vw" : "1vw",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          bgcolor="primary.main"
          color="primary.contrastText"
          p={2}
          borderRadius={1}
          sx={{ flex: 1, maxWidth: "2%", marginRight: "5px", boxShadow: 8 }}
        >
          <IconButton
            sx={{
              "&.MuiIconButton-root": {
                color: "white !important",
              },
            }}
            onClick={() => {
              navigate(-1);
              localStorage.removeItem("presentQuestionPaperId");
            }}
            size="small"
            title="Go Back"
          >
            <ArrowBackIcon />
          </IconButton>
        </Box>
        {!isViewMode && (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            bgcolor="primary.main"
            color="primary.contrastText"
            p={2}
            borderRadius={1}
            sx={{
              flex: 1,
              maxWidth: "8%",
              marginRight: "5px",
              boxShadow: 8,
              cursor: "pointer",
              fontSize: isMobile ? "75%" : "90%",
              fontWeight: "bold",
            }}
            onClick={handleOpen}
          >
            {isMobile || isTablet ? "SUBMIT" : "SUBMIT ALL"}
          </Box>
        )}
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          bgcolor="#E12027"
          color="primary.contrastText"
          p={2}
          borderRadius={1}
          sx={{ flex: 1, width: "auto", marginRight: "5px" }}
        >
          <Typography
            sx={{
              color: "white",
              fontSize: isMobile ? "75%" : isTablet ? "85%" : "90%",
            }}
          >
            LEVEL {levelId}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection={"column"}
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          bgcolor="#E12027"
          color="primary.contrastText"
          p={2}
          borderRadius={1}
          sx={{ flex: 1, width: "auto", marginRight: "5px" }}
        >
          <Typography
            sx={{
              color: "white",
              fontSize: isMobile ? "75%" : isTablet ? "85%" : "90%",
            }}
          >
            {lessonName}
          </Typography>
        </Box>
        {/* {isViewMode && (
          <Box
            display="flex"
            flexDirection={"column"}
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            bgcolor="#E12027"
            color="primary.contrastText"
            p={2}
            borderRadius={1}
            sx={{ flex: 1, width: "auto", marginRight: "5px" }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: isMobile ? "75%" : isTablet ? "85%" : "90%",
              }}
            >
              MARKS : {viewModeMarksScored}
            </Typography>
          </Box>
        )}
        {isViewMode && !isMobile && (
          <Box
            display="flex"
            flexDirection={"column"}
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            bgcolor="#E12027"
            color="primary.contrastText"
            p={2}
            borderRadius={1}
            sx={{ flex: 1, width: "auto", marginRight: "5px" }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: isMobile ? "75%" : isTablet ? "80%" : "90%",
              }}
            >
              CORRECTLY ANSWERED : {viewModeCorrectAnswered}
            </Typography>
          </Box>
        )} */}
        {!isMobile && (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            bgcolor="#E12027"
            color="primary.contrastText"
            p={2}
            borderRadius={1}
            sx={{ flex: 1, maxWidth: "auto" }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: isMobile ? "75%" : isTablet ? "85%" : "90%",
              }}
            >
              {isViewMode
                ? `ANSWERED : ${viewModeAnsweredQuestions}`
                : `ANSWERED : ${answeredQuestions}/${totalQuestions}`}
            </Typography>
          </Box>
        )}
      </Box>
      {isMobile && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="stretch"
          p={2}
          borderRadius={3}
          m={2}
          // bgcolor="#F2F2F2"
          sx={{
            height: isMobile ? "3vh" : "6vh",

            // paddingTop: "0px",
            margin: "2vw",
            marginTop: "0vh !important",
          }}
        >
          {/* {isViewMode && isMobile && (
            <Box
              display="flex"
              flexDirection={"column"}
              justifyContent="center"
              alignItems="center"
              textAlign="center"
              bgcolor="#E12027"
              color="primary.contrastText"
              p={2}
              borderRadius={1}
              sx={{ flex: 1, width: "auto", marginRight: "5px" }}
            >
              <Typography
                sx={{
                  color: "white",
                  fontSize: isMobile ? "75%" : isTablet ? "80%" : "90%",
                }}
              >
                CORRECTLY ANSWERED : {viewModeCorrectAnswered}
              </Typography>
            </Box>
          )} */}
          {isMobile && (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              textAlign="center"
              bgcolor="#E12027"
              color="primary.contrastText"
              p={2}
              borderRadius={1}
              sx={{ flex: 1, maxWidth: "30%" }}
            >
              <Typography
                sx={{
                  color: "white",
                  fontSize: isMobile ? "75%" : isTablet ? "85%" : "90%",
                }}
              >
                {isViewMode
                  ? `ANSWERED : ${viewModeAnsweredQuestions}/${totalQuestions}`
                  : `ANSWERED : ${answeredQuestions}/${totalQuestions}`}
              </Typography>
            </Box>
          )}
        </Box>
      )}

      <Paper
        elevation={2}
        sx={{
          margin: "3vh",
          marginTop: isMobile ? "1vh !important" : "3vh",
          backgroundColor: "#D9F6FF",
          minHeight: "75vh",
        }}
      >
        <Grid container lg={12} md={12} sm={12} xs={12}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Tabs
              value={tabValue}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              variant="scrollable"
              allowScrollButtonsMobile
              scrollButtons="auto"
              TabIndicatorProps={{
                style: {
                  // backgroundColor: "#F25E6B",
                  backgroundColor: "#E12027",
                },
              }}
              sx={{
                ".MuiTabScrollButton-root": {
                  color: "#F25E6B",
                },
              }}
            >
              {questionPaper.sectionList.map((section, index) => (
                // Render a tab for each section

                <Tab
                  key={index}
                  label={section.name}
                  style={{ fontSize: isMobile ? "100%" : "105%" }}
                />
              ))}
            </Tabs>

            <Box className="tab-content">
              {questionPaper.sectionList.map((section, index) => (
                // Render the corresponding panel for each section
                <TabPanel key={index} value={tabValue} index={index}>
                  <LayoutRenderer
                    sectionName={section.name}
                    questions={section.questionBank}
                  />
                </TabPanel>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default Homework;
